import React from 'react';

// Footer with Sudeco and UnB logos for all authenticated pages
const Footer = () => (
  <footer className="w-full flex justify-center items-center gap-16 py-2 bg-white shadow border-t border-gray-200">
    <img
      src="/images/logo_sudeco.png"
      alt="Logo Sudeco"
      className="h-8 w-auto object-contain"
    />
    <img
      src="/images/logo_unb.png"
      alt="Logo UnB"
      className="h-8 w-auto object-contain"
    />
  </footer>
);

export default Footer;
